import { dateToIso, formatIsoDay } from "./IsoDateInput";

/**
 * Khoảng ngày của màn danh sách (lọc theo ngày tạo phiếu). URL giữ TÊN preset
 * (?range=last_month) chứ không giữ ngày cụ thể, để link "This year" mở năm sau
 * vẫn là năm hiện tại. Khoảng tự chọn thì URL giữ from/to.
 *
 * Mặc định (URL không có gì) = This year.
 */
export const DEFAULT_RANGE = "this_year";
export const ALL_TIME = "all";

const day = (y, m, d) => dateToIso(new Date(y, m, d, 12));

export const PRESETS = [
  {
    key: "this_month", label: "This month",
    range: (t) => ({ from: day(t.getFullYear(), t.getMonth(), 1), to: day(t.getFullYear(), t.getMonth() + 1, 0) }),
  },
  {
    key: "last_month", label: "Last month",
    range: (t) => ({ from: day(t.getFullYear(), t.getMonth() - 1, 1), to: day(t.getFullYear(), t.getMonth(), 0) }),
  },
  {
    key: "this_quarter", label: "This quarter",
    range: (t) => {
      const q = Math.floor(t.getMonth() / 3) * 3;
      return { from: day(t.getFullYear(), q, 1), to: day(t.getFullYear(), q + 3, 0) };
    },
  },
  {
    key: "this_year", label: "This year",
    range: (t) => ({ from: day(t.getFullYear(), 0, 1), to: day(t.getFullYear(), 11, 31) }),
  },
  {
    key: "last_year", label: "Last year",
    range: (t) => ({ from: day(t.getFullYear() - 1, 0, 1), to: day(t.getFullYear() - 1, 11, 31) }),
  },
  { key: ALL_TIME, label: "All time", range: () => ({ from: "", to: "" }) },
];

const presetOf = (key) => PRESETS.find((p) => p.key === key);

/**
 * Đọc khoảng ngày từ URL params → { range, from, to }.
 *   from/to có mặt  → khoảng tự chọn (range = "custom")
 *   range hợp lệ    → preset đó
 *   không có gì     → This year
 */
export const resolveDateRange = ({ range, from, to }, today = new Date()) => {
  if (from || to) return { range: "custom", from: from || "", to: to || "" };
  const preset = presetOf(range) || presetOf(DEFAULT_RANGE);
  return { range: preset.key, ...preset.range(today) };
};

export const dateRangeLabel = ({ range, from, to }) => {
  if (range !== "custom") return presetOf(range)?.label || "Date";
  if (from && to) return `${formatIsoDay(from)} – ${formatIsoDay(to)}`;
  if (from) return `From ${formatIsoDay(from)}`;
  return `Until ${formatIsoDay(to)}`;
};
